/**
 * "Something changed, show it now" for socket events and order actions.
 *
 * With the sync loop running this is one cheap feed poll instead of
 * invalidating (and so re-reading in full) the order list; with no loop the old
 * invalidation is the fallback. The station view keeps its own query, so it is
 * still invalidated.
 */
import type { QueryClient } from "@tanstack/react-query";
import { requestFeedPoll } from "./feed-trigger";

export function refreshOrders(queryClient: Pick<QueryClient, "invalidateQueries">): void {
  if (!requestFeedPoll()) {
    queryClient.invalidateQueries({ queryKey: ["kitchen-orders"] });
  }
  queryClient.invalidateQueries({ queryKey: ["kitchen-station-orders"] });
}
